export function convertPriceToNumber(amount: string | number = 0): number {
	const a = `${amount || ''}`.replace(/ /g, '');
	return +a || 0;
}
